<template>
  <input class="form-control" v-model="displayValue" @blur="isInputActive = false" @input="input"
         @focus="isInputActive = true" placeholder="" :disabled="disabled"/>
</template>

<script>
  export default {
    props: {
      value: {
        required: true
      },
      placeholder: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      input: {
        type: Function,
        default: () => {
        }
      },
      onlyPositive: {
        type: Boolean,
        default: false
      },
      fractionDigits: {
        type: [String, Number],
        default: 2
      }
    },
    data() {
      return {
        isInputActive: false
      }
    },
    computed: {
      displayValue: {
        get() {
          if (this.isInputActive) {
            if (this.value !== null && this.value !== undefined) {
              return this.value.toString();
            }
            return '';
          } else {
            if (this.value !== null && this.value !== undefined && this.value !== '' && !isNaN(this.value)) {
              return Number(this.value).toFixed(this.fractionDigits);
            }
            return '';
          }
        },
        set(modifiedValue) {
          modifiedValue = modifiedValue.replace(',', '.');
          let newValue = modifiedValue.replace(/ [^\d\,.]/g, '');
          if (this.onlyPositive) {
            newValue = Math.abs(newValue);
          }
          if (isNaN(newValue) && newValue !== '-') {
            newValue = '';
          }
          this.$emit('input', newValue)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/FloatInput.vue